import { dayjsInPacificTZ } from "@/utils/dateUtils";
import { SalesSnapShotInterval } from "@boxem/core-api-schema";
import dayjs from "dayjs";

export const getStartEndOfDateRangeInterval = (from: Date | number | string, to?: Date | number | string): SalesSnapShotInterval => {
  const startOfYesterday = dayjs().subtract(1, 'day').startOf('day').valueOf();
  const shouldUsePacificTz = new Date(from).valueOf() >= startOfYesterday;
  const toDate = to ? new Date(to) : new Date(from);
  const fromWithOffset = shouldUsePacificTz ? dayjsInPacificTZ(from, true).startOf('day') : new Date(from);
  const toWithOffset = shouldUsePacificTz ? dayjsInPacificTZ(toDate, true).endOf('day') : new Date(toDate);
  const endOfInterval = dayjs(toWithOffset).isAfter(Date.now()) ? dayjs().subtract(1, 'hour').endOf('hour') : toWithOffset;

  return {
    from: fromWithOffset.valueOf(),
    to: endOfInterval.valueOf(),
    granularity: shouldUsePacificTz ? 'hour' : 'day',
  }
}


